import { xyz } from '@/Interfaces/common';
import {
    accessoryFileName,
    amhFileName, amhtcelFileName, amhtcFileName, hard1000FileName, hard2000FileName,
    hardFileName,
    tAccessoryFileName,
    tAmhFileName, tAmhtcelFileName, tAmhtcFileName, tc1095FileName, tc1947FileName, tc19952FileName, tc1995FileName,
    tcFileName, tHard1000FileName, tHard2000FileName,
    tHardFileName, tTc1095FileName, ttc19952FileName, tTc1995FileName,
    tTcFileName,
} from '@/Constants/glb';

export type boxModelMeta = Omit<Omit<iItemModel, 'name'>, 'fileName'> & {isSmall?: boolean};
export interface iItemModel {
    name: string,//=blenderName
    offset: xyz,
    scale: xyz,
    rotation: xyz,
    width: number,
    height: number,
    depth: number,
    decorPosition?: xyz,
    box?: boxModelMeta,
    fileName?: tc1947FileName | tTc1095FileName | tTc1995FileName | ttc19952FileName |
        tAmhtcFileName | tAmhtcelFileName | tHard1000FileName | tHard2000FileName |
        tHardFileName | tTcFileName | tAmhFileName | tAccessoryFileName;
}


export const modelMeta: iItemModel[] = [
    {
        name: 'hard_2000',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 1.15,
        height: 1.998,
        depth: 0.65,
        fileName: hard2000FileName,
    },
    {
        name: 'hard_1000',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.998,
        height: 1.15,
        depth: 0.65,
        fileName: hard1000FileName,
    },
    {
        name: 'amh_tc',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.92,
        height: 1.85,
        depth: 0.46,
        fileName: amhtcFileName,
    },
    {
        name: 'amh_tc_el',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.92,
        height: 1.85,
        depth: 0.46,
        fileName: amhtcelFileName,
    },
    {
        name: 'tc_1947',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.475,
        height: 1.9,
        depth: 0.5,
        fileName: tc1947FileName,
    },
    {
        name: 'tc_1995',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.95,
        height: 1.9,
        depth: 0.5,
        fileName: tc1995FileName,
    },
    {
        name: 'tc_1995_2',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.95,
        height: 1.9,
        depth: 0.5,
        fileName: tc19952FileName,
    },
    {
        name: 'tc_1095',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.95,
        height: 1.0,
        depth: 0.5,
        fileName: tc1095FileName,
    },
    {
        name: 'drawer_hard_60',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 1.017,
        height: 0.066,
        depth: 0.512,
        decorPosition: [ -0.42, 0, -0.2 ],
        box: {
            offset: [ 0, -0.025, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 1.017,
            height: 0.066,
            depth: 0.6,
            isSmall: false,
        },
        fileName: hardFileName,
    },
    {
        name: 'drawer_hard_125',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 1.017,
        height: 0.141,
        depth: 0.512,
        decorPosition: [ -0.42, 0, -0.2 ],
        box: {
            offset: [ 0, -0.025, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 1.017,
            height: 0.141,
            depth: 0.6,
            isSmall: false,
        },
        fileName: hardFileName,
    },
    {
        name: 'drawer_hard_265',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 1.017,
        height: 0.291,
        depth: 0.512,
        decorPosition: [ -0.42, 0, -0.2 ],
        box: {
            offset: [ 0, -0.025, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 1.017,
            height: 0.291,
            depth: 0.6,
            isSmall: false,
        },
        fileName: hardFileName,
    },
    {
        name: 'shelf_hard',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 1.035,
        height: 0.02,
        depth: 0.538,
        decorPosition: [ -0.42, 0, -0.2 ],
        box: {
            offset: [ 0, -0.02, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 1.035,
            height: 0.04,
            depth: 0.6,
            isSmall: false,
        },
        fileName: hardFileName,
    },
    {
        name: 'sliding_shelf_hard',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 1.036,
        height: 0,
        depth: 0.5,
        decorPosition: [ -0.42, 0, -0.2 ],
        box: {
            offset: [ 0, -0.033, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 1.036,
            height: 0.066,
            depth: 0.6,
            isSmall: false,
        },
        fileName: hardFileName,
    },
    {
        name: 'shelf_chpu_hard_40_s1',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 1.03,
        height: 0.03,
        depth: 0.17,
        decorPosition: [ -0.42, 0, -0.2 ],
        box: {
            offset: [ 0, -0.02, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 1.03,
            height: 0.26,
            depth: 0.6,
            isSmall: false,
        },
        fileName: hardFileName,
    },
    {
        name: 'shelf_chpu_hard_50_s1',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 1.03,
        height: 0.03,
        depth: 0.17,
        decorPosition: [ -0.42, 0, -0.2 ],
        box: {
            offset: [ 0, -0.02, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 1.03,
            height: 0.26,
            depth: 0.6,
            isSmall: false,
        },
        fileName: hardFileName,
    },
    {
        name: 'shelf_chpu_hard_63_s1',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 1.03,
        height: 0.03,
        depth: 0.17,
        decorPosition: [ -0.42, 0, -0.2 ],
        box: {
            offset: [ 0, -0.02, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 1.03,
            height: 0.26,
            depth: 0.6,
            isSmall: false,
        },
        fileName: hardFileName,
    },
    {
        name: 'shelf_chpu_hard_40_s2',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 1.03,
        height: 0.03,
        depth: 0.17,
        decorPosition: [ -0.42, 0, -0.2 ],
        box: {
            offset: [ 0, -0.02, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 1.03,
            height: 0.26,
            depth: 0.6,
            isSmall: false,
        },
        fileName: hardFileName,
    },
    {
        name: 'shelf_chpu_hard_50_s2',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 1.03,
        height: 0.03,
        depth: 0.17,
        decorPosition: [ -0.42, 0, -0.2 ],
        box: {
            offset: [ 0, -0.02, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 1.03,
            height: 0.26,
            depth: 0.6,
            isSmall: false,
        },
        fileName: hardFileName,
    },
    {
        name: 'shelf_chpu_hard_63_s2',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 1.03,
        height: 0.03,
        depth: 0.17,
        decorPosition: [ -0.42, 0, -0.2 ],
        box: {
            offset: [ 0, -0.02, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 1.03,
            height: 0.26,
            depth: 0.6,
            isSmall: false,
        },
        fileName: hardFileName,
    },
    {
        name: 'shelf_chpu_hard_40_s3',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 1.03,
        height: 0.03,
        depth: 0.17,
        decorPosition: [ -0.42, 0, -0.2 ],
        box: {
            offset: [ 0, -0.02, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 1.03,
            height: 0.26,
            depth: 0.6,
            isSmall: false,
        },
        fileName: hardFileName,
    },
    {
        name: 'shelf_chpu_hard_50_s3',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 1.03,
        height: 0.03,
        depth: 0.17,
        decorPosition: [ -0.42, 0, -0.2 ],
        box: {
            offset: [ 0, -0.02, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 1.03,
            height: 0.26,
            depth: 0.6,
            isSmall: false,
        },
        fileName: hardFileName,
    },
    {
        name: 'shelf_chpu_hard_63_s3',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 1.03,
        height: 0.03,
        depth: 0.17,
        decorPosition: [ -0.42, 0, -0.2 ],
        box: {
            offset: [ 0, -0.02, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 1.03,
            height: 0.26,
            depth: 0.6,
            isSmall: false,
        },
        fileName: hardFileName,
    },
    {
        name: 'shelf_chpu_hard',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 1.03,
        height: 0.03,
        depth: 0.17,
        decorPosition: [ -0.42, 0, -0.2 ],
        box: {
            offset: [ 0, -0.02, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 1.03,
            height: 0.26,
            depth: 0.6,
            isSmall: false,
        },
        fileName: hardFileName,
    },
    {
        name: 'perfo_screen_hard',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 1.037,
        height: 0.149,
        depth: 0.026,
        decorPosition: [ -0.42, 0, -0.2 ],
        box: {
            offset: [ 0, -0.035, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 1.037,
            height: 0.14,
            depth: 0.03,
            isSmall: false,
        },
        fileName: hardFileName,
    },
    {
        name: 'table_hard_1000',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 1.094,
        height: 0.03,
        depth: 0.645,
        decorPosition: [ -0.42, 0, -0.2 ],
        box: {
            offset: [ 0, 1, -0.02 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 1.094,
            height: 0.03,
            depth: 0.649,
            isSmall: false,
        },
        fileName: hardFileName,
    },
    {
        name: 'shelf_amh_tc',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.84,
        height: 0.03,
        depth: 0.39,
        decorPosition: [ -0.42, 0, -0.2 ],
        box: {
            offset: [ 0, 0, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 0.84,
            height: 0.029,
            depth: 0.42,
            isSmall: false,
        },
        fileName: amhFileName,
    },
    {
        name: 'shelf_chpu_amh_tc_40',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.84,
        height: 0.17,
        depth: 0.4,
        decorPosition: [ -0.42, 0, -0.2 ],
        box: {
            offset: [ 0, -0.02, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 0.84,
            height: 0.18,
            depth: 0.41,
            isSmall: false,
        },
        fileName: amhFileName,
    },
    {
        name: 'shelf_chpu_amh_tc_50',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.84,
        height: 0.17,
        depth: 0.4,
        decorPosition: [ -0.42, 0, -0.2 ],
        box: {
            offset: [ 0, -0.02, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 0.84,
            height: 0.18,
            depth: 0.41,
            isSmall: false,
        },
        fileName: amhFileName,
    },
    {
        name: 'shelf_chpu_amh_tc_63',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.84,
        height: 0.17,
        depth: 0.4,
        decorPosition: [ -0.42, 0, -0.2 ],
        box: {
            offset: [ 0, -0.02, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 0.84,
            height: 0.18,
            depth: 0.41,
            isSmall: false,
        },
        fileName: amhFileName,
    },
    {
        name: 'drawer_amh_tc_60',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.84,
        height: 0.06,
        depth: 0.4,
        decorPosition: [ -0.42, 0, -0.2 ],
        box: {
            offset: [ 0, -0.05, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 0.84,
            height: 0.06,
            depth: 0.41,
            isSmall: false,
        },
        fileName: amhFileName,
    },
    {
        name: 'drawer_amh_tc_125',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.84,
        height: 0.125,
        depth: 0.4,
        decorPosition: [ -0.42, 0, -0.2 ],
        box: {
            offset: [ 0, -0.05, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 0.84,
            height: 0.125,
            depth: 0.41,
            isSmall: false,
        },
        fileName: amhFileName,
    },
    {
        name: 'wardrobe_kit_tcsh',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.47,
        height: 0.029,
        depth: 0.433,
        decorPosition: [ -0.42, 0, -0.23 ],
        box: {
            offset: [ 0.035, -0.08, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 0.4,
            height: 0.1,
            depth: 0.44,
            isSmall: true,
        },
        fileName: tcFileName,
    },
    {
        name: 'tc_shelf_chpu_sk_40',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.918,
        height: 0.225,
        depth: 0.434,
        decorPosition: [ -0.42, 0, -0.23 ],
        box: {
            offset: [ 0, -0.02, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 0.918,
            height: 0.23,
            depth: 0.435,
            isSmall: false,
        },
        fileName: tcFileName,
    },
    {
        name: 'tc_shelf_chpu_sk_50',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.918,
        height: 0.225,
        depth: 0.434,
        decorPosition: [ -0.42, 0, -0.23 ],
        box: {
            offset: [ 0, -0.02, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 0.918,
            height: 0.23,
            depth: 0.435,
            isSmall: false,
        },
        fileName: tcFileName,
    },
    {
        name: 'tc_shelf_chpu_hsk_63',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.918,
        height: 0.225,
        depth: 0.434,
        decorPosition: [ -0.42, 0, -0.23 ],
        box: {
            offset: [ 0, -0.02, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 0.918,
            height: 0.23,
            depth: 0.434,
            isSmall: false,
        },
        fileName: tcFileName,
    },
    {
        name: 'ver_wall_tcd_1800',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.03,
        height: 1.86,
        depth: 0.47,
        box: {
            offset: [ 0, 0.1, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 0.03,
            height: 1.8,
            depth: 0.48,
            isSmall: false,
        },
        fileName: tcFileName,
    },
    {
        name: 'ver_wall_tcd_1800_2',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.945,
        height: 0.814,
        depth: 0.47,
        box: {
            offset: [ 0, 0.793, 0.01 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 0.93,
            height: 0.02,
            depth: 0.43,
            isSmall: false,
        },
        fileName: tcFileName,
    },
    {
        name: 'ver_wall_tcd_900',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.005,
        height: 0.951,
        depth: 0.5,
        box: {
            offset: [ 0, 0.05, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 0.033,
            height: 0.895,
            depth: 0.5,
            isSmall: false,
        },
        fileName: tcFileName,
    },
    {
        name: 'set_niches_tc_1995',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        //1780x485x457
        width: 0.485,
        height: 1.78,
        depth: 0.457,
        box: {
            offset: [ 0.035, 0, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 0.45,
            height: 1.78,
            depth: 0.458,
            isSmall: true,
        },
        fileName: tcFileName,
    },
    {
        name: 'lateral_screen_ms',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.398,
        height: 0.5,
        depth: 0.020,
        box: {
            offset: [ 0.045, -0.03, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 0.398,
            height: 1,
            depth: 0.020,
            isSmall: true,
        },
        fileName: tcFileName,
    },
    {
        name: 'perfo_screen_tcs_50x43',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.435,
        height: 0.5,
        depth: 0.020,
        box: {
            offset: [ 0.035, -0.024, -0.015 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 0.4,
            height: 0.47,
            depth: 0.02,
            isSmall: true,
        },
        fileName: tcFileName,
    },
    {
        name: 'drawerL_tcf_87x45',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        decorPosition: [ -0.42, 0, -0.2 ],
        width: 0.874,
        height: 0.14,
        depth: 0.45,
        box: {
            offset: [ 0, 0, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 0.874,
            height: 0.12,
            depth: 0.46,
            isSmall: false,
        },
        fileName: tcFileName,
    },
    {
        name: 'drawer_tcf_39x45',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        decorPosition: [ -0.42, 0, -0.2 ],
        width: 0.39,
        height: 0.1,
        depth: 0.45,
        box: {
            offset: [ 0.05, -0.01, 0.01 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 0.38,
            height: 0.13,
            depth: 0.45,
            isSmall: true,
        },
        fileName: tcFileName,
    },
    {
        name: 'drawerS_tcf_42x45',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.42,
        height: 0.14,
        depth: 0.45,
        box: {
            //offset[0] отступ от центра шкафа
            //от 0 до box.height отступ от верха комплектующего
            offset: [ 0.02, 0, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 0.41,
            height: 0.12,
            depth: 0.46,
            isSmall: true,
        },
        fileName: tcFileName,
    },
    {
        name: 'perfo_screen_amh_tc',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.84,
        height: 0.3,
        depth: 0.01,
        box: {
            offset: [ 0, -0.01, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 0.84,
            height: 0.29,
            depth: 0.01,
            isSmall: false,
        },
        fileName: amhFileName,
    },
    {
        name: 'shelfS_tcsh_43x47',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        //25x470x430 мм.
        width: 0.47,
        height: 0.029,
        depth: 0.43,
        decorPosition: [ -0.42, 0, -0.2 ],
        box: {
            offset: [ 0.035, 0, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 0.4,
            height: 0.024,
            depth: 0.44,
            isSmall: true,
        },
        fileName: tcFileName,
    },
    {
        name: 'shelfL_tcsh_95x47',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.945,
        height: 0.029,
        depth: 0.43,
        decorPosition: [ -0.42, 0, -0.2 ],
        box: {
            offset: [ 0, 0, 0 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 0.945,
            height: 0.024,
            depth: 0.44,
            isSmall: false,
        },
        fileName: tcFileName,
    },
    {
        name: 'paper_towel_holder_pth',
        offset: [ 0, 0, 0.004 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.36,
        height: 0.092,
        depth: 0.126,
        box: {
            offset: [ 0.13, -0.07, 0.004 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 0.36,
            height: 0.092,
            depth: 0.126,
            isSmall: false,
        },
        fileName: accessoryFileName,
    },
    {
        name: 'wh_key_holder',
        offset: [ 0, 0, 0.004 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.120,
        height: 0.25,
        depth: 0.030,
        box: {
            offset: [ 0, -0.07, 0.004 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 0.120,
            height: 0.25,
            depth: 0.030,
            isSmall: false,
        },
        fileName: accessoryFileName,
    },
    {
        name: 'hexagon_holder_hh',
        offset: [ 0, 0, 0.004 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.160,
        height: 0.04,
        depth: 0.050,
        box: {
            offset: [ 0.055, -0.035, 0.004 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 0.160,
            height: 0.04,
            depth: 0.050,
            isSmall: false,
        },
        fileName: accessoryFileName,
    },
    {
        name: 'plastic_box_holder_200_SPBH',
        offset: [ 0, 0, 0.004 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.190,
        height: 0.089,
        depth: 0.013,
        box: {
            offset: [ 0.055, -0.0445, 0.004 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 0.190,
            height: 0.089,
            depth: 0.013,
            isSmall: false,
        },
        fileName: accessoryFileName,
    },
    {
        name: 'shelf_large_lsh',
        offset: [ 0, 0, 0.004 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.53,
        height: 0.07,
        depth: 0.151,
        box: {
            offset: [ 0.25, -0.06, 0.01 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 0.53,
            height: 0.07,
            depth: 0.151,
            isSmall: false,
        },
        fileName: accessoryFileName,
    },
    {
        name: 'tray_holder_a4',
        offset: [ 0, 0, 0.004 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.3,
        height: 0.2,
        depth: 0.06,
        box: {
            offset: [ 0.132, -0.165, 0.004 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 0.3,
            height: 0.2,
            depth: 0.06,
            isSmall: false,
        },
        fileName: accessoryFileName,
    },
    {
        name: 'plastic_box_400x230x150',
        offset: [ 0, 0, 0 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.23,
        height: 0.17,
        depth: 0.4,
        box: {
            offset: [ 0.06, -0.2, 0.004 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 0.23,
            height: 0.19,
            depth: 0.4004,
            isSmall: false,
        },
        fileName: accessoryFileName,
    },
    {
        name: 'ushm_holder',
        offset: [ 0, 0, 0.004 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.4,
        height: 0.055,
        depth: 0.065,
        box: {
            offset: [ 0.09, -0.034, 0.004 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 0.4,
            height: 0.055,
            depth: 0.065,
            isSmall: false,
        },
        fileName: accessoryFileName,
    },
    {
        name: 'hook_hk_2_80',
        offset: [ 0, 0, 0.004 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0.025,
        height: 0.06,
        depth: 0.08,
        box: {
            offset: [ 0, -0.01, 0.004 ],
            scale: [ 1, 1, 1 ],
            rotation: [ 0, 0, 0 ],
            width: 0.1,
            height: 0.06,
            depth: 0.08,
            isSmall: false,
        },
        fileName: accessoryFileName,
    },
    //TODO Напоминание: для дверей имя = 'dr_'/'dl_' + имя шкафа
    {
        name: 'dr_amh_tc',
        offset: [ 0.44926756620407104, 0.11555465310811996, 0.42993178963661194 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0,
        height: 0,
        depth: 0,
    },
    {
        name: 'dl_amh_tc',
        offset: [ -0.44926756620407104, 0.11555465310811996, 0.42993178963661194 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0,
        height: 0,
        depth: 0,
    },
    {
        name: 'dr_tc_1947',
        offset: [ 0.475, 0.065, 0.48 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0,
        height: 0,
        depth: 0,
    },
    {
        name: 'dl_tc_1995',
        offset: [ -0.4668000042438507, 0.06419999897480011, 0.47290998697280884 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0,
        height: 0,
        depth: 0,
    }, {
        name: 'dr_tc_1995',
        offset: [ 0.4668000042438507, 0.06419999897480011, 0.47290998697280884 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0,
        height: 0,
        depth: 0,
    },
    {
        name: 'dl_tc_1095',
        offset: [ -0.4663214385509491, 0.028901901096105576, 0.4729006886482239 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0,
        height: 0,
        depth: 0,
    }, {
        name: 'dr_tc_1095',
        offset: [ 0.4663214385509491, 0.028901901096105576, 0.4729006886482239 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0,
        height: 0,
        depth: 0,
    },
    {
        name: 'dr_hard_2000',
        offset: [ 0.5324400067329407, 0.0866200253367424, 0.6202099919319153 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0,
        height: 0,
        depth: 0,
    },
    {
        name: 'dl_hard_2000',
        offset: [ -0.5324400067329407, 0.0866200253367424, 0.6202099919319153 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0,
        height: 0,
        depth: 0,
    },
    {
        name: 'dr_hard_1000',
        offset: [ 0.5324400067329407, 0.08661998808383942, 0.6202099919319153 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0,
        height: 0,
        depth: 0,
    },
    {
        name: 'dl_hard_1000',
        offset: [ -0.5324400067329407, 0.08661998808383942, 0.6202099919319153 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0,
        height: 0,
        depth: 0,
    },
    {
        name: 'dr_amh_tc_el',
        offset: [ 0.44926756620407104, 0.11555465310811996, 0.42993178963661194 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0,
        height: 0,
        depth: 0,
    },
    {
        name: 'dl_amh_tc_el',
        offset: [ -0.44926756620407104, 0.11555465310811996, 0.42993178963661194 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0,
        height: 0,
        depth: 0,
    },
    {
        name: 'dr_tc_1995_2',
        offset: [ 0.468085914850235, 0.06443186104297638, 0.4723831117153168 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0,
        height: 0,
        depth: 0,
    },
    {
        name: 'dl_tc_1995_2',
        offset: [ -0.468085914850235, 0.06443186104297638, 0.4723831117153168 ],
        scale: [ 1, 1, 1 ],
        rotation: [ 0, 0, 0 ],
        width: 0,
        height: 0,
        depth: 0,
    },
];
